import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Electromagnetic Pulse',
  date: new Date(2023, 7, 20),
  img: '/img/robot.jpeg',
  tracks: [
    {
      title: 'Leaving Room for Jesus',
      src: '/songs/2023-08-20/leaving_room_for_jesus.mp3',
    },
    {
      title: 'Walking Down Memory Lane',
      src: '/songs/2023-08-20/walking_down_memory_lane.mp3',
    },
    {
      title: 'Going Boldy Where',
      src: '/songs/2023-08-20/going_boldly_where.mp3',
    },
    {
      title: 'Dreaming Out Loud',
      src: '/songs/2023-08-20/dreaming_out_loud.mp3',
    },
    {
      title: 'Crunching the Numbers',
      src: '/songs/2023-08-20/crunching_the_numbers.mp3',
    },
    {
      title: 'Calling your Bluff',
      src: '/songs/2023-08-20/calling_your_bluff.mp3',
    },
    {
      title: 'Relying on Public Transit',
      src: '/songs/2023-08-20/relying_on_public_transit.mp3',
    },
    {
      title: 'Being here with You',
      src: '/songs/2023-08-20/being_here_with_you.mp3',
    },
    {
      title: 'Taking you Down',
      src: '/songs/2023-08-20/taking_you_down.mp3',
    },
    {
      title: 'Getting down with You',
      src: '/songs/2023-08-20/getting_down_with_you.mp3',
    },
    {
      title: 'Peeling back Layers',
      src: '/songs/2023-08-20/peeling_back_layers.mp3',
    },
    {
      title: 'Preparing to Get Down',
      src: '/songs/2023-08-20/preparing_to_get_down.mp3',
    },
    {
      title: 'Communicating with Aliens',
      src: '/songs/2023-08-20/communicating_with_aliens.mp3',
    },
    {
      title: 'Following the Yellow Brick Road',
      src: '/songs/2023-08-20/following_the_yellow_brick_road.mp3',
    },
    {
      title: 'Warning: This Song is all about Werner Herzog\'s Totally Normal Penis',
      src: '/songs/2023-08-20/preparing_to_get_down.mp3',
    },
    {
      title: 'Anthropomorphizing Robots',
      src: '/songs/2023-08-20/anthropomorphizing_robots.mp3',
    },
  ]
}
export default album;